import React from 'react';
import { Table, Button, Input, Card, Modal, message, Col, Select, Popover, TreeSelect, Divider, Transfer} from 'antd';
import common from '../../assets/common.js';
import moment from 'moment';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';
const Option = Select.Option;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
class MemberTable extends React.Component {
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      visible: false,
      key: "",
      value: "",
      example:[],
      targetKeys: [],
      selectedKeys: [],
      dataSource: [],
      dataSourceUser: [],
      selectedKeysUser: [],
      targetKeysUser: [],
      type: "add",
      alarmId: null
    }
  }
  componentWillMount(){
    let this_ = this;
    this.showTableCol();
  }
  componentDidMount(){
    this.getArea();
    this.getRoom();
    this.getUser();
    this.getList();
  }
  getArea = () => {
    let this_ = this;
    var postData = {};
    if(sessionStorage.getItem("subAdmin")) {
      postData["_url"] = "api/admin/area";
    } else {
      postData["_url"] = "api/dc/access/area";
    }
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data) {
      let ar = data.result.subList.map(function(index){
        let arr1 = [];
        if(index.dcBuildingList.length !== 0) {
          let ar2 = index.dcBuildingList.map(function(item) {
            let arr2 = {};
            if(item.roomList.length !== 0) {
              let ar3 = item.roomList.map(function(dataItem) {
                let arr3 = {};
                arr3["title"] = dataItem.roomName;
                arr3["key"] = "roomId" + dataItem.roomId;
                arr3["id"] = dataItem.roomId;
                arr3["value"] = "roomId" + dataItem.roomId;
                arr3["dept"] = 3;
                let example = this_.state.example;
                example.push(arr3)
                this_.setState({
                  example
                })
                return arr3;
              })
              arr2["children"] = ar3;
            }
            arr2["title"] = item.building;
            arr2["key"] = "buildingId" + item.buildingId;
            arr2["id"] = item.buildingId;
            arr2["value"] = "buildingId" + item.buildingId;
            arr2["dept"] = 2;
            let example = this_.state.example;
            example.push(arr2)
            this_.setState({
              example
            })
            return arr2;
          });
          arr1["children"] = ar2;
        }
        arr1["title"] = index.areaName;
        arr1["key"] = "areaId" + index.areaId;
        arr1["id"] = index.areaId;
        arr1["value"] = "areaId" + index.areaId;
        arr1["dept"] = 1;
        let example = this_.state.example;
        example.push(arr1)
        this_.setState({
          example
        })
        return arr1;
      });
      // console.log(this_.state.example);
      obj.setState({
        treeData: ar
      })
    }, function(obj, state) {

    })
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '区域',
      dataIndex: 'areaName',
      must: true,
      show: true,
      width: '80px'
    }, {
      title: '楼栋',
      dataIndex: 'buildingName',
      must: false,
      show: true,
      width: '100px',
    }, {
      title: '楼门',
      dataIndex: 'roomName',
      must: false,
      show: true,
      width: '120px'
    }, {
      title: '报警联系人',
      dataIndex: 'realNameList',
      must: true,
      show: true,
      width : "100px",
      render: (text, record) => (
        <span>{record.alarmItemBo?record.alarmItemBo.realNameList:'--'}</span>
      )
    }, {
      title: '操作',
      must: true,
      show: true,
      width : "120px",
      render: (text, record) => {
        return (
          <div>
            <a className="a-theme" onClick={() => this.edit(record)}>修改</a>
            <Divider type="vertical"/>
            <a className="a-theme" onClick={() => this.delete(record)}>删除</a>
          </div>
        )
      }
    }];
    table = common.getEcardTable(table);
    // console.log(table);
    this.setState({ table });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current)
  }
  thisOk = () => {
    this.getList();
  }
  edit = (record) => {
    this.setState({
      visible: true,
      type: "edit",
      alarmId: record.alarmId,
      targetKeysUser: record.alarmItemBo.alarmUserIds
    })
  }
  delete = (record) => {
    var postData = {};
    postData["_url"] = "api/alarm";
    postData["_method"] = "DELETE";
    postData["id"] = record.alarmId;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination.current);
      message.success("删除成功");
    });
  }
  getRoom = () => {
    var postData = {};
    postData["_url"] = "api/dc/room/list";
    postData["_method"] = "GET";
    common.request(postData, this, function(obj, data){
      const result = data.result;
      if(result.length > 0) {
        result.map((item, i) => {
          item.key = item.roomId,
          item.title = item.name
        });
      }
      // console.log(result);
      obj.setState({
        dataSource: result
      })
    },function(obj, state){
      message.warning(state.message);
    });
  }
  getUser= () => {
    var postData = {};
    postData["_url"] = "api/alarm/user/search";
    postData["_method"] = "POST";
    postData["pageSize"] = 1000;
    common.request(postData, this, function(obj, data){
      const result = data.result.list;
      if(result.length > 0) {
        result.map((item, i) => {
          item.key = item.alarmUserId,
          item.title = item.realName
        });
      }
      // console.log(result);
      obj.setState({
        dataSourceUser: result
      })
    },function(obj, state){
      message.warning(state.message);
    });
  }
  getList = (pageInfo, filters, sorter) =>{
    var this_ = this;
    const pn = pageInfo ? pageInfo: 1;
    const table = this.state.table;
    let roomIds = [];
    let buildings = [];
    let areaIds = [];
    this.state.example.map((item) => {
      if(this_.state.value.indexOf(item.value) > -1) {
        if(item.dept === 3) {
          roomIds.push(item.id);
        } else if(item.dept === 2){
          buildings.push(item.id);
        } else {
          areaIds.push(item.id);
        }
      }
    });
    var postData = {};
    postData["_url"] = "api/alarm/search";
    postData["pageNum"] = pn;
    postData["pageSize"] = 10;
    if(roomIds.length > 0) {
      postData["roomIds"] = roomIds;
    }
    if(buildings.length > 0) {
      postData["buildingIds"] = buildings;
    }
    if(areaIds.length > 0) {
      postData["areaIds"] = areaIds;
    }
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  handleCancel = ()=> {
    this.setState({
      visible: false
    });
  }
  setUserName = (e) => {
    this.setState({
      userName: e.target.value
    })
  }
  onChangeTree = (value) => {
    // console.log(value);
    this.setState({ value });

  }
  showRule = () => {
    this.setState({
      visible: true
    })
  }
  addRule = () => {
    let targetKeys = this.state.targetKeys;
    let targetKeysUser = this.state.targetKeysUser;
    if(targetKeys.length === 0 || targetKeysUser.length === 0) {
      message.warning("请选择完整");
      return;
    }
    var postData = {};
    postData["_url"] = "api/alarm";
    postData["roomIds"] = this.state.targetKeys;
    postData["alarmUserIds"] = this.state.targetKeysUser;
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.setState({
        visible: false
      })
      message.success("添加成功");
      const pagination = obj.state.table.pagination;
      obj.getList(pagination.current);
    },function(obj, state){
      message.warning(state.message);
    });
  }
  editRule = () => {
    let targetKeysUser = this.state.targetKeysUser;
    if(targetKeysUser.length === 0) {
      message.warning("请选择联系人");
      return;
    }
    var postData = {};
    postData["_url"] = "api/alarm";
    postData["_method"] = "PUT";
    postData["alarmId"] = this.state.alarmId;
    postData["alarmUserIds"] = this.state.targetKeysUser;
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.setState({
        visible: false
      })
      const pagination = obj.state.table.pagination;
      obj.getList(pagination.current);
      message.success("修改成功");
    },function(obj, state){
    });
  }
  handleTransferChange = (nextTargetKeys, direction, moveKeys) => {
    this.setState({ targetKeys: nextTargetKeys });
  };
  handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({ selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys] });
  };

  handleScroll = (direction, e) => {
  }
  handleTransferChangeUser = (nextTargetKeys, direction, moveKeys) => {
    this.setState({ targetKeysUser: nextTargetKeys });
  };
  handleSelectChangeUser = (sourceSelectedKeys, targetSelectedKeys) => {
    this.setState({ selectedKeysUser: [...sourceSelectedKeys, ...targetSelectedKeys] });
  };

  handleScrollUser = (direction, e) => {
  }

  render(){
    const { table, targetKeys, selectedKeys, dataSource, targetKeysUser, selectedKeysUser, dataSourceUser, type} = this.state;
    const pswtitle = "请用支付宝扫码查看"+ this.state.orgName +"的密码";
    const tProps = {
      treeData: this.state.treeData,
      allowClear: true,
      value: this.state.value,
      onChange: this.onChangeTree,
      treeCheckable: true,
      showCheckedStrategy: SHOW_PARENT,
      searchPlaceholder: '请选择区域',
      style: {
        width:320
      },
    };
    return(
      <Card>
        <div>
          <div className="table-menu clearfix">
            <Col span={16}>
              <label>区&emsp;域：</label>
              <TreeSelect {...tProps} style={{width:200}}/>
              <Button type="primary" style={{marginLeft: 15}} onClick={ this.thisOk }>查询</Button>
            </Col>
            <Col span={8}>
              <Button type="primary" onClick={this.showRule}>新增报警规则</Button>
              <div className="pull-right">
                { table.show && <MenuAction obj={ this }/> }
              </div>
            </Col>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            <div className="table-total">共{ table.pagination.total }条数据</div>
          </div>
          <div style={{color: "#F52E38"}}>报警规则说明：设备离线5分钟，1小时，1天系统将自动发送报警信息；消息将通过微信发出，请报警联系人绑定微信；</div>
          <Modal
            title={type === "add"?"新增报警规则":"修改报警规则"}
            visible={this.state.visible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancel}
            width={700}
            footer={[
              <Button type="primary" onClick={type === "add"?this.addRule:this.editRule}>{type === "add"?"新增":"修改"}</Button>,
              <Button onClick={this.handleCancel}>关闭</Button>
            ]}
          >
          { type === "add" && <div>
              <div style={{paddingBottom:15}}>选择报警区域：</div><Transfer
                dataSource={dataSource}
                titles={['未选区域', '已选区域']}
                targetKeys={targetKeys}
                selectedKeys={selectedKeys}
                onChange={this.handleTransferChange}
                onSelectChange={this.handleSelectChange}
                onScroll={this.handleScroll}
                render={item => item.title}
                listStyle={{
                  width: 300
                }}
              />
            </div>
          }
          <div style={{paddingTop:15,paddingBottom:15}}>选择报警联系人：</div>
          <Transfer
            dataSource={dataSourceUser}
            titles={['未选联系人', '已选联系人']}
            targetKeys={targetKeysUser}
            selectedKeys={selectedKeysUser}
            onChange={this.handleTransferChangeUser}
            onSelectChange={this.handleSelectChangeUser}
            onScroll={this.handleScrollUser}
            render={item => item.title}
            listStyle={{
              width: 300
            }}
          />
          </Modal>
        </div>
      </Card>
    )
  }
}
export default MemberTable;



// WEBPACK FOOTER //
// ./src/component/devicealarm/alarmrule.js